/**
 * Internal dependencies
 */
import { normalizeTextBoxAttachments } from '../utils/textBoxAttachment';
import { getTextBoxAdjustedElement } from './element';

function normalizePageElements(elements) {
  return normalizeTextBoxAttachments(
    elements.map((element) => getTextBoxAdjustedElement(element)),
    { previousElements: elements }
  );
}

export default normalizePageElements;
